export function getMessage(message, args) {
    const glosbe = window.glosbe;
    let retVal = message.default;
    if (glosbe && glosbe.i18n) {
        retVal = glosbe.i18n[message.code] || message.default;
    }
    if (args && retVal.indexOf("{") >= 0) {
        const parts = retVal.split(/{[^}]+}/);
        const buffer = [];
        for (let i = 0; i < parts.length; i++) {
            buffer.push(parts[i]);
            if (i < args.length) {
                buffer.push(args[i]);
            }
        }
        retVal = buffer.join("");
    }
    return retVal;
}
export function getUserLocale() {
    return document.documentElement.lang;
}
